import styled from 'styled-components'
import { Link } from 'react-router-dom'
import {
  LEGACY_BREAKPOINT_QUERIES,
  createResponsiveBreakpointQuery
} from 'styles/breakpoints'

const mobileQuery = createResponsiveBreakpointQuery('mobileDown', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.mobileDown
})

const tabletQuery = createResponsiveBreakpointQuery('tabletUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.tabletUp
})

const smallDesktopQuery = createResponsiveBreakpointQuery('smallDesktopUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.smallDesktopUp
})

const desktopQuery = createResponsiveBreakpointQuery('desktopUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.desktopUp
})

const largeDesktopQuery = createResponsiveBreakpointQuery('largeDesktopUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.largeDesktopUp
})

const ultraWideQuery = createResponsiveBreakpointQuery('largeDesktopUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.releasesUltraWideUp
})

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.neutralW10};
`

export const TitleContainer = styled.div`
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.neutralW30}`};
  display: grid;
  grid-gap: 4px;

  @media ${tabletQuery} {
    padding: 16px;
    grid-template-columns: 3fr 1fr 1.5fr 1.5fr 1fr 0.5fr;
  }

  @media ${desktopQuery} {
    grid-template-columns: 2fr 0.5fr 1fr 1fr 1fr 1fr 1fr 0.5fr;
  }
`

export const TableContentWrapper = styled.div`
  display: grid;
  gap: ${({ $isMobile }) => ($isMobile ? 0 : '4px')};
`

export const ContentContainer = styled.div`
  display: grid;
  grid-gap: 8px;
  grid-template-columns: minmax(0, 1fr) 32px;
  padding: 8px 0;
  margin-bottom: 0;

  @media ${tabletQuery} {
    padding: 16px;
    grid-gap: 4px;
    margin-bottom: 0;
    grid-template-columns: 3fr 1fr 1.5fr 1.5fr 1fr 0.5fr;
  }

  @media ${desktopQuery} {
    grid-gap: 4px;
    grid-template-columns: 2fr 0.5fr 1fr 1fr 1fr 1fr 1fr 0.5fr;
  }

  align-items: center;

  @media ${smallDesktopQuery} {
    &:hover,
    &[data-context-menu-open='true'] {
      background-color: ${({ theme }) => theme.colors.neutralW20};
      cursor: pointer;

      .action_btn {
        display: flex;
        /* opacity: 1; */
      }
    }
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 4px;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
export const ArtistWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;

  @media ${mobileQuery} {
    max-width: 100%;
  }

  svg {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
`

export const ArtistRow = styled.div`
  display: flex;
  flex-direction: row;
`

export const BadgeWrapper = styled.div`
  text-align: left;
  display: flex;
  flex-direction: row;
`
export const MoreActionsWrapper = styled.div`
  padding: 8px;
`
export const Title = styled.div`
  text-align: left;
  padding: 8px;
  flex: 1;
  font-weight: 600;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.neutralW70};
`

export const Content = styled.div`
  padding: 8px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.neutralW90};
  flex: 1;
  white-space: nowrap;
  overflow: ${({ $isActionColumn }) =>
    $isActionColumn ? 'visible' : 'hidden'};
  text-overflow: ellipsis;
`

export const MobileActionContent = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`

export const ReleaseIdentity = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  overflow: visible;
`

export const ReleaseArtworkWrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  max-width: 60px;
  aspect-ratio: 1 / 1;
  flex: 0 0 60px;
  justify-content: center;
  margin-right: 12px;

  @media ${mobileQuery} {
    max-width: 36px;
    flex-basis: 36px;
    margin-right: 8px;
  }
`

export const Image = styled.img`
  width: 100%;
  height: 60px;
  object-fit: cover;
  border: ${({ $isMobile, theme }) =>
    $isMobile ? `1px solid ${theme.colors.neutralW20}` : ''};
  border-radius: 5px;

  @media ${mobileQuery} {
    height: 36px;
  }
`
export const MobileContent = styled.div`
  font-size: 12px;
  font-weight: ${({ $isTitle }) => ($isTitle ? 600 : 400)};
  line-height: 12px;
  gap: 4px;
  color: ${({ theme }) => theme.colors.neutralW90};
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;

  @media ${mobileQuery} {
    max-width: 100%;
  }

  @media ${largeDesktopQuery} {
    max-width: 200px;
  }

  @media ${ultraWideQuery} {
    max-width: 250px;
  }
`

export const ReleaseInfoLink = styled(Link)`
  display: block;
  position: relative;
  width: fit-content;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  color: inherit;
  cursor: pointer;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;

  &::after {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 1px;
    background: currentColor;
    content: '';
    opacity: 0;
    pointer-events: none;
  }

  &:hover::after,
  &:focus-visible::after {
    opacity: 1;
  }
`

export const PlayIconWrapper = styled.div`
  position: absolute;
  bottom: 0;
  top: 50%;
  transform: translateY(-50%);
  justify-content: center;
  align-items: center;
  display: none;
`
